import { ToastChakra } from "../helpers/toast";
import api from "../helpers/api";


const baseURL = process.env.REACT_APP_API_URL;

const getAllUsuarios = async (data) => {
    const { page, perPage } = data;
    const response = await api.get(`${baseURL}/usuario/listar?pagina=${page}&cantidadPagina=${perPage}`);
    return response.data;  // Aquí obtienes el objeto con `data` y `pagination`
}
const createUsuario = async (data) => {
    const response = await api.post(`${baseURL}/usuario/crear`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('USUARIO CREADO', 'El usuario se ha creado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}
const deleteUsuario = async (id) => {
    const response = await api.delete(`${baseURL}/usuario/eliminar/${id}`);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('USUARIO ELIMINADO', 'El usuario se ha eliminado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}
const updateUsuario = async (data) => {
    const response = await api.put(`${baseURL}/usuario/actualizar/${data.id}`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('USUARIO MODIFICADO', 'El usuario se ha modificado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

const resetPassword = async (data) => {
    const response = await api.put(`${baseURL}/usuario/reset-password/${data.id}`, data);
    return response.data;
}


const usuarsioService = {
    getAllUsuarios,
    createUsuario,
    deleteUsuario,
    updateUsuario,
    resetPassword
}
export default usuarsioService;
